import xpointService from '../geolocation/services/providers/xpoint/xpjsService.js'
// import { XpointLauncher } from '../geolocation/sdkScripts/xpoint/index.js'

const SDK_CONFIG = {
  GEOCOMPLY: {
    name: 'GEOCOMPLY',
    url: 'https://cdn.geocomply.com/plc/' + (window.ctsautoconf.GEOLOCATION && window.ctsautoconf.GEOLOCATION.GEOCOMPLY.PLUGIN_VERSION) + '/geocomply-client.min.js',
    globalVar: 'geocomplySDK',
    htmlSection: 'body',
    srcType: 'module',
    async: true
  },
  LEXISNEXIS: {
    name: 'LEXISNEXIS',
    url: '/static/geolocation/lexisNexis/ln_toolkit.js',
    globalVar: 'lexisnexisSDK',
    htmlSection: 'head',
    srcType: 'text/javascript'
  },
  XPOINT: {
    name: 'XPOINT',
    url: window.ctsautoconf.GEOLOCATION && window.ctsautoconf.GEOLOCATION.XPOINT && window.ctsautoconf.GEOLOCATION.XPOINT.SDK_CDN,
    globalVar: 'xpointSDK',
    htmlSection: 'body',
    srcType: 'text/javascript',
    launcher: '../geolocation/sdkScripts/xpoint/index.js',
    solution: window.ctsautoconf.GEOLOCATION && window.ctsautoconf.GEOLOCATION.XPOINT && window.ctsautoconf.GEOLOCATION.XPOINT.SOLUTION
  }
}

class SDKLoader {
  constructor (providerName, isDebug = false) {
    this.debug = isDebug
    if (!SDK_CONFIG[providerName]) {
      throw new Error(`Unknown provider: ${providerName}`)
    }
    this.config = SDK_CONFIG[providerName]
  }

  loadSDK () {
    return new Promise((resolve, reject) => {
      // Check if SDK is loaded already.
      if (window[this.config.globalVar]) {
        if (this.debug) console.log(`[SDK loader] ${this.config.name} SDK already loaded.`)
        return resolve(window[this.config.globalVar])
      }

      // Check if loading SDK is in progress.
      if (document.querySelector(`script[src="${this.config.url}"]`)) {
        if (this.debug) console.log(`[SDK loader] ${this.config.name} SDK is loading...`)
        const checkExist = () => {
          if (window[this.config.globalVar]) {
            resolve(window[this.config.globalVar])
          } else {
            setTimeout(checkExist, 100)
          }
        }
        return checkExist()
      }

      // Add <script> tag
      const script = document.createElement('script')
      script.src = this.config.url
      if (this.config.async) script.async = this.config.async
      if (this.config.srcType) script.type = this.config.srcType
      script.onload = () => {
        if (this.debug) console.log(`[SDK loader] ${this.config.name} SDK loaded.`)
        resolve(window[this.config.globalVar] = true)
        if (this.config.name === 'XPOINT' && this.config.solution === 'Lite') xpointService.init(true)
        // if (this.config.name === 'XPOINT' && this.config.solution === 'Verify') {
        //   const launcher = new XpointLauncher()
        //   launcher.openURL('xpoint://launch')
        // }
      }
      script.onerror = () => {
        reject(new Error(`[SDK loader] Failed to load ${this.config.name} SDK`))
      }
      document[this.config.htmlSection].appendChild(script)
    })
  }
}

export default SDKLoader



// WEBPACK FOOTER //
// ./src/library/geolocation/sdkLoader.js